<template>
    <div class="topnav page-topnav" style="padding: 0 12px; max-height: none; overflow-y: visible">
        <div class="container-fluid">
            <nav class="navbar navbar-light navbar-expand topnav-menu">
                <div class="navbar-collapse align-items-center justify-content-between">
                    <ul class="navbar-nav">
                        <li class="nav-item">
                            <h6>{{ pageTitle() }}</h6>
                        </li>
                    </ul>
                    <ul class="navbar-nav">
                        <li class="nav-item" style="height: 36.5px">
                            <div style="position: absolute; height: 36.5px; right: 0">
                                <button
                                    v-if="($route.name == 'my-account')"
                                    :key="'email-support'"
                                    type="button"
                                    class="btn btn-primary"
                                    data-toggle="modal"
                                    data-target="#email-support-modal"
                                    @click.prevent="resetSupportForm()"
                                >
                                    <i class="far fa-envelope mr-1" style="position: relative; top: 1px"></i>
                                    {{ $root.text('Email support', null, true) }}
                                </button>
                                <button
                                    v-if="($route.name == 'my-account-user-groups')"
                                    :key="'add-user-group'"
                                    type="button"
                                    class="btn btn-primary"
                                    data-toggle="modal"
                                    data-target="#user-group-add-form-modal"
                                    @click.prevent="resetUserGroupAddForm()"
                                >
                                    <i class="far fa-users-medical mr-1"></i>
                                    {{ $root.text('Add user group', null, true) }}
                                </button>
                                <router-link
                                    v-if="($route.name != 'my-account') && ($route.name != 'my-account-user-groups')"
                                    :key="'my-account'"
                                    :to="{ name: 'my-account' }"
                                    custom
                                    v-slot="{ navigate }"
                                >
                                    <button class="btn btn-primary" @click="navigate">
                                        <i class="far fa-user mr-1"></i> {{ $root.text('My account', null, true) }}
                                    </button>
                                </router-link>
                            </div>
                        </li>
                    </ul>
                </div>
            </nav>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                //
            }
        },
        mounted () {
            //
        },
        methods: {
            pageTitle: function () {
                switch (this.$route.name) {
                    case 'my-account-uploads':
                        return this.$root.text('My uploads', null, true);
                    case 'my-account-downloads':
                        return this.$root.text('My downloads', null, true);
                    case 'my-account-assets-awaiting-approval':
                        return this.$root.text(
                            '{resources} awaiting approval',
                            {
                                resources: this.$root.text(this.$root.contents.asset_title + 's', null, false,
                                    'assets_title')
                            },
                            true
                        );
                    case 'my-account-assets-approved':
                        return this.$root.text(
                            '{resources} approved',
                            {
                                resources: this.$root.text(this.$root.contents.asset_title + 's', null, false,
                                    'assets_title')
                            },
                            true
                        );
                    case 'my-account-collections-shared':
                        return this.$root.text('Collections shared', null, true);
                    case 'my-account-flytes-sent':
                        return this.$root.text('Flytes sent', null, true);
                    case 'my-account-print-orders':
                        return this.$root.text('Orders', null, true);
                    case 'my-account-artworks-awaiting-approval':
                        return this.$root.text('Items awaiting approval', null, true);
                    case 'my-account-artworks-approved':
                    case 'my-account-artwork-approved':
                        return this.$root.text('Approved items', null, true);
                    case 'my-account-artworks-declined':
                    case 'my-account-artwork-declined':
                        return this.$root.text('Declined items', null, true);
                    case 'my-account-artwork-actions':
                        return this.$root.text(
                            '{template} approval history',
                            {
                                template: this.$root.text(
                                    this.$root.contents.template_title,
                                    null,
                                    false,
                                    'template_title'
                                )
                            },
                            true
                        );
                    case 'my-account-user-groups':
                        return this.$root.text('Personal user groups', null, true);
                    default:
                        return this.$root.text('My account', null, true);
                }
            },
            resetSupportForm: function () {
                const appComponent = this.$root.findComponent(this.$root, 'main-app');
                const component = this.$root.findComponent(appComponent, 'email-support');
                if (component) {
                    component.resetForm();
                }
            },
            resetUserGroupAddForm: function () {
                const pageComponent = this.$root.findComponent(this.$parent.$parent, 'my-account-user-groups');
                if (pageComponent) {
                    const component = this.$root.findComponent(pageComponent, 'user-group-add-form');
                    if (component) {
                        component.resetForm();
                    }
                }
            }
        }
    }
</script>
